export default "__VITE_ASSET__Di3_l2S$__"